<template>
  <ob-modal2 :show.sync="generatePopup" :backdrop="false" width="800px">
    <template slot="modal-title" v-if="!generatePopupSuccessContent">
      Generate Evaluation Report
    </template>
    <template slot="modal-body">
      <div v-if="generatePopupSuccessContent">
        <img class="center" style="height:150px;display: block; margin-left: auto; margin-right: auto;" src="https://hrmscdn.onblick.com/commonimages/oblaptop-downloadobk.svg" /> <br/>
        <p style="text-align:center;font-size:16px;">We have started preparing your evaluation report, it will take few minutes.</p>
        <p style="text-align:center;font-size:16px">We will send you the report to <b>{{this.empInfo.Email}}</b> once it is generated.</p>
      </div>
      <div v-else>
        <div class="row form-group">
          <div class="col-md-12">
            <label style="font-size:13px;margin-left:16px;margin-bottom:-20px;">Enter a date range to generate a Evaluation report. You can customize the report by selecting one of the options provided below.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" style="margin-top:10px;">
            <div class="col-md-6" style="margin-bottom:20px;">
              <label>Select Range</label><span class="validation-star">*</span>
              <div class="row">
                <div class="col-md-6">
                  <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateFrom" id="dateFrom" :options="options" :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"  v-model.trim="dateFrom"  :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error }"></ob-date-time-picker>
                  <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required">Please select From Date</span>
                </div>
                <div class="col-md-6">
                  <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateTo" id="dateTo" :options="options" :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo"  :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error }" ></ob-date-time-picker>
                  <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required">Please select To Date</span>
                </div>
              </div>
            </div>
          </div>
        </div>     
        <div  class="row form-group">
          <div class="col-md-12" style="padding-left:30px;">
            <ob-radio name="options" v-model="ReportType" val="EvaluationReport">Evaluation Report</ob-radio>
            <ob-radio name="options" v-model="ReportType" val="TasksDetails">Tasks details</ob-radio>
            <ob-radio name="options" v-model="ReportType" val="EvaluationReportTasks">Evaluation Report and Tasks details</ob-radio>
            <ob-radio name="options" v-model="ReportType" val="EvaluationReportTasksEvaluations">Evaluation Report, Tasks details and Comments</ob-radio>
            <ob-radio name="options" v-model="ReportType" val="EvaluationReportTasksEvaluationsComments">Evaluation Report, Tasks details and Comments with Dates</ob-radio>
            <ob-radio name="options" v-model="ReportType" val="EvaluationReportTasksEvaluationsCommentsWithDates">Evaluation Report, Tasks details, Comments with Dates and Evaluations</ob-radio>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button  v-if="generatePopupSuccessContent" type="secondary" @click="cancel()">Ok, Got it</ob-button>
      <ob-button  v-if="!generatePopupSuccessContent" type="secondary" @click="cancel()">Cancel</ob-button>
      <ob-button  v-if="!generatePopupSuccessContent" @click="generate()"> Generate </ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
export default {
  props:["show", "EmployeeId"],
  data()
  {
    return {
      keyValueUpdate:0,
     // showReportOptions :true,
      StartDate:'',
      EndDate:'',
      ReportType: 'EvaluationReport',
      dateFrom:'',
      dateTo:'',
      isLoading:false,
      generatePopup:false,
      generatePopupSuccessContent:false,
      empInfo: [],
      options: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate:moment('01/01/1970').format('MM/DD/YYYY'),
        maxDate: moment().add(1, 'M'),
      },
    }
  },
  // computed: {
  //   email() {
  //     return this.empInfo ? this.empInfo.Email : null;
  //   },
  // },
 
    
  
  methods:{
    resetValues(){
      this.dateFrom = '',
      this.dateTo = '',
      this.$v.dateFrom.$reset(),
      this.$v.dateTo.$reset()
    },
    cancel(){
      this.generatePopup = false
      this.generatePopupSuccessContent = false
      //this.EmpType = 'IndividualEmployee'
    },
    successContent(){
      this.generatePopupSuccessContent=false
    },
    onFromDateChange(e) {
      setTimeout(() => {
        let d1 = e.date.format('MM/DD/YYYY')
        this.$refs.dateTo.data.minDate(d1)
      }, 100)
    },
    organizationList() {
      ajax.get(
        // `Employee/${loggedInUserObj.email}/EmployeeOrganizationList`,
        `Employee/${loggedInUserObj.consultantId}/EmployeeOrganizationList`,
        {},
        res => {
          if (res.data.State == true) {
           
            this.empInfo = res.data.organizationBasicInfoList.EmployeeInfo;
          } else {
            this.ESSEnableDisable(res);
          }
        }
      );
    },
    generate()
    {
      this.$v.dateFrom.$touch();
      this.$v.dateTo.$touch();

      if(this.$v.dateFrom.$invalid == false && this.$v.dateTo.$invalid == false){
      this.$loading({ 'loadingText': 'Loading...' })

      var Obj =
        {
        "FromDate": this.dateFrom,
        "ToDate": this.dateTo,
        "EmployeeId": this.EmployeeId,
        "ReportType":this.ReportType,
        // "empOrgId":this.loggedInUserObj.orgId,
        "empOrgId":"",
        "ConnectionId" :$.connection.notificationHub.connection.id
      }
      ajax.put(`TimeSheets/CustomReport`, Obj , res => {
        if(res.data.State == true) {
          //      this.$message({
          //     type: 'success',
          //     message: "Timesheet Added Successfully"
          //   });
          this.generatePopupSuccessContent=true
          // this.cancel();
          if(res.data.Message == 'Reports are Generating')
          {
              // events.fire("IsTimesheetInProgress",true);
              // if(this.$route.name == 'evaluation')
              // {
              //    this.$parent.$refs.draggablTimesheetReportProgress.reportType = "Evaluation";
              //    this.$parent.$refs.draggablTimesheetReportProgress.showTimesheetDraggablePopUp = true;

              // }
              // else{
              //      this.$parent.$parent.$parent.$refs.draggablTimesheetReportProgress.reportType = "Evaluation";
              //      this.$parent.$parent.$parent.$refs.draggablTimesheetReportProgress.showTimesheetDraggablePopUp = true;
              // }
          }
          else
          {
              window.open(res.data.ReportUrl, "_blank");
          }
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          })
          }
      })
      }

  },
 },
  
  created()
  {
    this.generatePopup=this.show
    //this.getEmployeeList()
    this.ReportType= 'EvaluationReport',
    this.resetValues();
    this.organizationList();
  },
  validations()
  {
    return{
      "dateFrom":{
        required
      },
      "dateTo":{
        required
      },
    }
  },

    
    watch: {
      show(val) {
        if(val){
          this.ReportType ="EvaluationReport"
          this.resetValues();
          this.generatePopup = val;
        }
      },
      generatePopup(val) {
        this.$emit('update:show', val);
      },
    }
  }
</script>
<style>
 .validation-star{
    color: #F31D1D;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/GenerateEvalutionReport.vue